// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const CarouselNavArrow = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 58 58" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M29 0C12.984 0 0 12.984 0 29s12.984 29 29 29 29-12.984 29-29S45.016 0 29 0Zm-2.513 16.387 11.376 11.375a1.75 1.75 0 0 1 0 2.475L26.487 41.612a1.746 1.746 0 0 1-2.475 0 1.75 1.75 0 0 1 0-2.475L34.15 29 24.012 18.862a1.75 1.75 0 0 1 2.475-2.475Z"
			fill="#FFF"
			fillRule="evenodd"
			fillOpacity={0.6}
		/>
	</svg>
);
export default CarouselNavArrow;
